import { render } from "./KancolleReplay.vue?vue&type=template&id=6ff0c77f"
import script from "./KancolleReplay.vue?vue&type=script&lang=js"
export * from "./KancolleReplay.vue?vue&type=script&lang=js"
script.render = render

export default script